import { ApeironLinkButton, NextImage } from '@apeiron/temp'
import { styled } from '@mui/material'
import ExternalSVG from '@public/icons/icon-external.svg'
import * as R from 'ramda'

const Link = styled(ApeironLinkButton)`
  aspect-ratio: 1;
  width: 20px;
  margin-left: 10px;

  :hover {
    filter: brightness(0) saturate(100%) invert(72%) sepia(24%) saturate(703%)
      hue-rotate(5deg) brightness(101%) contrast(98%);
  }
`

const LinkIcon = styled(NextImage)`
  height: 100%;
  width: 100%;
`

const ParagraphBlockLinkButton = (props: Props) => {
  const { className, href } = props

  return R.isNotNil(href) ? (
    <Link className={className} url={href}>
      <LinkIcon src={ExternalSVG} />
    </Link>
  ) : null
}

type Props = {
  className?: string
  href?: string
}

export default ParagraphBlockLinkButton
